export const HOSTS = {
    HOST_INTERNAL: "ops.zomans.com",  
};